module.exports = __webpack_public_path__ + "img/antes_despues_259.252d2199.png";